
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/press/[slug]",
      function () {
        return require("private-next-pages/[lang]/press/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/press/[slug]"])
      });
    }
  